"use strict";function __export(r){for(var e in r)exports.hasOwnProperty(e)||(exports[e]=r[e])}__export(require("./classes")),__export(require("./color-picker.directive")),__export(require("./color-picker.module")),__export(require("./color-picker.service"));
//# sourceMappingURL=index.js.map



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular2-color-picker/lib/index.js
 ** module id = 29
 ** module chunks = 2
 **/